import axiosInstance from "../api/axios";

// Type definition
export interface NewsUpdatesData {
  title: string;
  slug: string;
  content: string;
  image: string;
  status: "publish" | "draft";
}

// NewsUpdates List
export const getNewsUpdates = async (status?: string) => {
  try {
    const response = await axiosInstance.get(`/newsupdates/list/`, {
      params: {
        status,
      },
    });
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};

// CREATE NewsUpdate
export const createNewsUpdates = async (data: NewsUpdatesData) => {
  try {
    const response = await axiosInstance.post(`/newsupdates/`, data);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};

// UPDATE NewsUpdate
export const updateNewsUpdates = async (id: number, data: NewsUpdatesData) => {
  try {
    const response = await axiosInstance.put(`/newsupdates/${id}`, data);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};

// NewsUpdates By ID
export const getNewsUpdatesById = async (id: number) => {
  try {
    const response = await axiosInstance.get(`/newsupdates/${id}`);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};

// NewsUpdates By Slug
export const getNewsUpdatesBySlug = async (slug: string) => {
  try {
    const response = await axiosInstance.get(`/newsupdates/by-slug/${slug}`);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};

// NewsUpdates Delete
export const deleteNewsUpdates = async (id: number) => {
  try {
    const response = await axiosInstance.delete(`/newsupdates/${id}`);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};